import React from "react";
import { Link } from "react-router-dom";
import { BookOpen } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="footer" className="border-t border-white/5 bg-black/40 mt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <BookOpen className="w-6 h-6 text-violet-400" />
              <span className="font-heading text-lg font-bold text-white">
                Pass<span className="text-violet-400">Points</span>
              </span>
            </Link>
            <p className="text-sm text-zinc-500 leading-relaxed">
              Your study companion. Access notes, question papers, syllabus, and lab manuals for all engineering branches.
            </p>
          </div>
          <div>
            <h4 className="font-heading text-sm font-semibold text-white mb-4">Platform</h4>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-sm text-zinc-500 hover:text-white transition-colors">Universities</Link>
              <Link to="/resources" className="text-sm text-zinc-500 hover:text-white transition-colors">Resources</Link>
            </div>
          </div>
          <div>
            <h4 className="font-heading text-sm font-semibold text-white mb-4">Tools</h4>
            <div className="flex flex-col gap-2">
              <Link to="/resources?resource_type=pyq" className="text-sm text-zinc-500 hover:text-white transition-colors">Question Papers</Link>
              <Link to="/resources?resource_type=notes" className="text-sm text-zinc-500 hover:text-white transition-colors">Notes</Link>
              <Link to="/cgpa-calculator" className="text-sm text-zinc-500 hover:text-white transition-colors">CGPA Calculator</Link>
            </div>
          </div>
          <div>
            <h4 className="font-heading text-sm font-semibold text-white mb-4">Admin</h4>
            <div className="flex flex-col gap-2">
              <Link to="/admin" className="text-sm text-zinc-500 hover:text-white transition-colors">Admin Panel</Link>
            </div>
          </div>
        </div>
        <div className="border-t border-white/5 mt-8 pt-8 text-center">
          <p className="text-xs text-zinc-600">
            PassPoints. Built for engineering students.
          </p>
        </div>
      </div>
    </footer>
  );
}
